import { useEffect, useRef, useState } from 'react';

const stats = [
  { val:500, suf:'+',  label:'브랜드 파트너', note:'국내외 다양한 산업' },
  { val:98,  suf:'%',  label:'고객 만족도',   note:'재계약률 92%' },
  { val:340, suf:'%',  label:'평균 ROI 상승', note:'6개월 기준 캠페인' },
  { val:7,   suf:'년', label:'운영 경력',     note:'2018년 설립' },
];

function CountUp({ target, suffix }) {
  const [n, setN] = useState(0);
  const ref = useRef(null);
  const done = useRef(false);
  useEffect(() => {
    const obs = new IntersectionObserver(([e]) => {
      if (e.isIntersecting && !done.current) {
        done.current = true;
        const t0 = performance.now();
        const tick = now => {
          const p = Math.min((now - t0) / 1600, 1);
          setN(Math.floor((1 - Math.pow(1 - p, 3)) * target));
          if (p < 1) requestAnimationFrame(tick); else setN(target);
        };
        requestAnimationFrame(tick);
        obs.disconnect();
      }
    }, { threshold: 0.5 });
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, [target]);
  return (
    <span ref={ref} className="font-headline font-black tabular-nums"
      style={{ fontSize:'clamp(44px,5.5vw,72px)' }}>
      {n}{suffix}
    </span>
  );
}

export default function Stats() {
  return (
    <section className="bg-ink border-b-4 border-red py-16 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center gap-4 mb-8">
          <div className="bg-red text-paper font-sans text-xs font-black tracking-widest px-3 py-1.5 uppercase">
            수치로 보는 현황
          </div>
          <div className="flex-1 border-t border-paper/20" />
          <span className="font-mono text-xs text-paper/30">BY THE NUMBERS</span>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 divide-x divide-paper/10">
          {stats.map(s => (
            <div key={s.label} className="px-8 py-6 text-center first:pl-0">
              <div className="text-red mb-1">
                <CountUp target={s.val} suffix={s.suf} />
              </div>
              <div className="font-sans font-semibold text-sm text-paper mb-0.5">{s.label}</div>
              <div className="font-mono text-xs text-paper/30">{s.note}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
